import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { handleWialonLogin } from "@lib/utils/login";

const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex h-screen items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(/assets/bg.jpg)`,
      }}
    >
      <div className="w-full max-w-lg bg-white/90 p-20 shadow-lg backdrop-blur-sm">
        <Typography
          variant="h3"
          className="mb-12 text-center font-bold text-gray-800"
        >
          {t("user.login.welcomeBack")}
        </Typography>
        <Button
          onClick={handleWialonLogin}
          variant="contained"
          fullWidth
          className="p-4 mb-4"
          endIcon={
            <img src="/assets/wialon-logo.png" alt="Wialon" className="h-6" />
          }
        >
          {t("user.login.loginWithWialon")}
        </Button>
      </div>
    </div>
  );
};

export default LoginPage;
